export enum PasswordCriteria {
  Number,
  UpperCase,
  LowerCase,
  SpecialSymbol
}
